import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const parent = (delay) => ({ hidden: {}, show: { transition: { staggerChildren: 0.1, delayChildren: delay } } });
const child = { hidden: { y: "108%" }, show: { y: "0%", transition: { duration: 1.15, ease: EASE } } };

export const MaskText = ({ lines, as = "h2", className = "", onLoad = false, delay = 0, ...rest }) => {
  const M = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <M className={className} initial="hidden" variants={parent(delay)} {...trigger} {...rest}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span className="block" variants={child}>
            {l}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <Reveal y={12} className={className}>
    <span className="eyebrow">{children}</span>
  </Reveal>
);
